import { useLanguage } from '../../context/LanguageContext';

/**
 * Compact DE/EN toggle for headers.
 * Persists via LanguageContext (localStorage).
 */
const LangToggle = ({ className = '' }) => {
  const { lang, setLanguage } = useLanguage();

  return (
    <div
      className={`inline-flex items-center rounded-full bg-[#1A2B42] p-0.5 text-xs font-medium ${className}`}
      data-testid="lang-toggle"
    >
      <button
        type="button"
        onClick={() => setLanguage('de')}
        className={`px-3 py-1 rounded-full transition ${
          lang === 'de'
            ? 'bg-[#00D9C8] text-[#0A1628]'
            : 'text-[#A0AEC0] hover:text-white'
        }`}
        data-testid="lang-toggle-de"
      >
        DE
      </button>
      <button
        type="button"
        onClick={() => setLanguage('en')}
        className={`px-3 py-1 rounded-full transition ${
          lang === 'en'
            ? 'bg-[#00D9C8] text-[#0A1628]'
            : 'text-[#A0AEC0] hover:text-white'
        }`}
        data-testid="lang-toggle-en"
      >
        EN
      </button>
    </div>
  );
};

export default LangToggle;
